import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('LogoutController', LogoutController);

    /** @ngInject */
    function LogoutController($state, AuthFactory, LocalStorageService) {
        AuthFactory.authLogout().then(function () {
            LocalStorageService.removeLocalData();
            $state.go('login');
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/partials/login/controllers/logout.controller.ts